<template lang="pug">
section.wam-content.onboarding-cclone(
    v-if="hasUserAccessToCclone"
    :class="onboardingCcloneClass")

    //- Loading data
    template(v-if="isLoadingCclone")
        spinner.l-flex-row--center.l-align-center(width="200" height="200")

    template(v-else)

        //- Modal CCLONE FORM
        div.overlay-close(
            v-if="displayCcloneForm || displayCcloneDelete"
            @click="closeForm()")

        div.modal(
            v-if="displayCcloneForm || displayCcloneDelete"
            :class="classModal")
            CcloneForm(v-if="displayCcloneForm")
            ConfirmationModal(v-else-if='displayCcloneDelete' modalClassName='modal-wrapper')
                template(slot='content')
                    div Are you sure you want to delete this Cclone ?
                template(slot='footer')
                    div.footer-content.l-flex-row--between
                        button.btn.btn--medium.btn--round(@click="closeForm()") Cancel
                        button.btn.btn--medium.btn--round.btn-rev.btn-delete(@click.once="deleteCclone()") Delete

        //- Zero state
        template(v-if="ccloneList.length === 0")
            section.l-flex-column.is-empty.zero-state
                p.zero-state-message There are no Cclone on your account.
                button.btn.btn--round.btn-rev.btn--big(
                    v-if="!disabledCcloneAction"
                    @click="newCclone()") Create Cclone

        template(v-else)
            //- CCLONE MONITORING
            CcloneMonitoring(:class="{'cclone-monitoring-is-loading': false}")

            //- PANEL JOB INFORMATION
            Panel(panelClassName="cclone-information" v-if="selectedCcloneId !== null")
                template(slot="header")
                    sectionHeader(title="details")
                template(slot="content")
                    CcloneDetails(:ccloneInfo="ccloneInfo")

            aside.cclone-information.no-data-selected(v-else)
                p No cclone selected.
                    br
                    | Please select a Cclone.
</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
// Components
import CcloneForm from '@/components/onBoarding/CcloneForm'
import CcloneMonitoring from '@/components/onBoarding/CcloneMonitoring'
import CcloneDetails from '@/components/onBoarding/CcloneDetails'
import Panel from '@/components/common/Panel'
import SectionHeader from '@/components/common/SectionHeader'
import ConfirmationModal from '@/components/common/confirmationModal'

export default {
    name: 'CClone',
    components: { CcloneForm, CcloneMonitoring, CcloneDetails, Panel, SectionHeader, ConfirmationModal },

    data() {
        return {
            displayCcloneConfirmationModal: false
        }
    },

    created() {
        if (this.hasUserAccessToCclone) {
            this.retrieveItems()
        }
    },

    watch: {
        hasUserAccessToCclone: {
            handler: function(val) {
                if (val) {
                    this.retrieveItems()
                }
            }
        }
    },

    computed: {
        // Call to state
        ...mapState('ui/cclone', {
            displayCcloneForm: state => state.displayModal.ccloneCreation,
            displayCcloneDelete: state => state.displayModal.cclonedelete,
            eventType: state => state.eventType,
            selectedCcloneId: state => state.selectedRowId
        }),
        ...mapState('ui/builder', {
            isLoadingCclone: state => state.isLoading.cclone.list
        }),
        // Call to getters
        ...mapGetters('data/cclone', ['getFormattedCclones', 'getItemById']),
        ...mapGetters('account', ['getAccessToCclone', 'getIsCcloneActionAllowed']),
        ...mapGetters('ui/builder', ['criteriaListIsReady']),

        // UI
        onboardingCcloneClass() {
            if ((this.isLoadingCclone || this.ccloneList.length === 0) && this.selectedCcloneId === null) return 'full-width'
            // if (this.selectedCcloneId === null) return 'not-selected'
            return false
        },

        ccloneList() {
            return this.getFormattedCclones()
        },

        hasUserAccessToCclone() {
            return this.getAccessToCclone()
        },

        ccloneInfo() {
            const _info = this.getItemById({ id: this.selectedCcloneId })
            // @TODO error notification
            if (_info === false) return null
            return _info
        },
        disabledCcloneAction() {
            return !this.getIsCcloneActionAllowed()
        },

        classModal() {
            let classModal = ''
            if (this.displayCcloneDelete) classModal = 'modal-h-auto modal__small modal-delete'
            else if (this.displayExportForm) classModal = 'modal-h-auto modal__medium modal-form-export'
            else if (this.displayCcloneForm) classModal = 'modal-h-full modal__medium modal-cclone'
            return classModal
        }
    },

    methods: {
        // Call to actions
        ...mapActions('data/cclone', ['retrieveItems', 'deleteItem']),
        ...mapActions('dashboardAccount', ['retrieveCcloneList']),
        // Call to mutations
        ...mapMutations('ui/cclone', ['setDisplayModal', 'resetEventsStoreOnCcloneFormClose']),
        ...mapMutations('exports', ['setExportForm']),

        closeForm() {
            this.setExportForm({ display: false, type: '' })
            this.setDisplayModal({ modal: 'ccloneCreation', isDisplayed: false })
            this.setDisplayModal({ modal: 'events', isDisplayed: false })
            this.setDisplayModal({ modal: 'cclonedelete', isDisplayed: false })
            this.resetEventsStoreOnCcloneFormClose()
        },
        async deleteCclone() {
            this.closeForm()
            await this.deleteItem({ itemId: this.selectedCcloneId })
            this.retrieveCcloneList()
        },
        newCclone() {
            this.setDisplayModal({ modal: 'ccloneCreation', isDisplayed: true })
        }
    }
}
</script>
